"use strict";

var str = "razdwatrzy";

module.exports = function () {
	if (typeof str.contains !== "function") return false;
	return (str.contains("dwa") === true) && (str.contains("foo") === false);
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/string/#/contains/is-implemented.js
// module id = 1555
// module chunks = 0